import { render, staticRenderFns } from "./AdminUsersTable.vue?vue&type=template&id=0422cb59&scoped=true"
import script from "./AdminUsersTable.vue?vue&type=script&lang=js"
export * from "./AdminUsersTable.vue?vue&type=script&lang=js"
import style0 from "./AdminUsersTable.vue?vue&type=style&index=0&id=0422cb59&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0422cb59",
  null
  
)

export default component.exports